'use strict';

import { CoreRepository } from '../CoreRepository';
import { AgencyAgentNpn } from '../../Entities/Agency/AgencyAgentNpn';
export class AgencyAgentNpnRepository extends CoreRepository {
  /*
    public getAgencyAgentNpn(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getAgencyAgentNpn(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let AgencyAgentNpn = new AgencyAgentNpn();
            AgencyAgentNpn.hydrate(response);

            return AgencyAgentNpn;
        });
    }

    public createAgencyAgentNpn(payload: object = {}){  
    return this.webAPI.createAgencyAgentNpn(payload)
      .then( response => {
        let AgencyAgentNpn = new AgencyAgentNpn();
        AgencyAgentNpn.hydrate(response);

        return AgencyAgentNpn;
      });
    }

    public updateAgencyAgentNpn(payload: object = {}){  
        return this.webAPI.updateAgencyAgentNpn(payload)
        .then( response => {
            let AgencyAgentNpn = new AgencyAgentNpn();
            AgencyAgentNpn.hydrate(response);

            return AgencyAgentNpn;
        });
    }

    public removeAgencyAgentNpn( ){
        return this.webAPI.removeAgencyAgentNpn()
        .then( response => {
            return response;
        });
    }
    */
}
